import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Card } from 'antd';
import api from '../../api';
import helpers from '../../helpers'
import CustomDataTable from '../../components/custom-data-table/custom-data-table';
import { setDefaultAddMovieTitle } from '../../redux/reducers/app-actions/app-actions.actions';



let _columnHeaders = [
  {
    label: 'Title',
    // field: 'title',
    field: 'title',
    formatter: 'titleFormatted',
    sort: 'asc',
    width: 250
  },
  {
    label: 'Rating',
    field: 'rating',
    formatter: null,
    sort: 'asc',
    width: 50
  },
  {
    label: 'Duration',
    field: 'duration_mins',
    formatter: 'duration_minsFormatted',
    sort: 'asc',
    width: 50
  },
  {
    label: 'Is 3D',
    field: 'is3D',
    formatter: 'is3DFormatted',
    sort: 'asc',
    width: 50
  },
  {
    label: 'Release Date',
    field: 'release_date',
    formatter: 'release_dateFormatted',
    sort: 'desc',
    width: 150
  },
];

let _pageNumOffset = 1;

let _paginationOpts = {
  l: 10, // 20, // 5, // 10,
  // l: 4, // TODO: Joe-
};

class MoviesListView extends Component {

  constructor(props) {
    super(props);

    this.movieHelper = helpers.movie;

    let pageData = CustomDataTable.EmptyPageData;
    pageData.maxItemsPerPage = _paginationOpts.l;
    pageData.activePageIdx = 0;
    pageData.firstPageIdx = 0;
    pageData.lastPageIdx = 0;
    // pageData.pageDisplayOffset = 0;

    let sortData = CustomDataTable.EmptySortData;

    this.state = {
      items: null,
      pageData: pageData,
      sortData: sortData,
      tableSearch: null,
      // tableSort: null,
      // tablePage: null,
    };


    this.handleAddClicked = this.handleAddClicked.bind(this);
    this.handleSearchChanged = this.handleSearchChanged.bind(this);
    this.handleSortChanged = this.handleSortChanged.bind(this);
    this.handlePageChanged = this.handlePageChanged.bind(this);
    this.handleRowClicked = this.handleRowClicked.bind(this);
    this.invalidateData = this.invalidateData.bind(this);

    // clear the stored title during init
    this.props.setDefaultAddMovieTitle(null);

    this.invalidateData();
  }

  handleAddClicked(e) {
    this.props.setDefaultAddMovieTitle(this.state.tableSearch || null);
    this.props.history.push('/movies/add');
  }

  handleSearchChanged(e) {
    // console.log('handleSearchChanged: ' + JSON.stringify(e));
    this.setState({ tableSearch: e }, this.invalidateData);
  }

  handleSortChanged(e) {
    // console.log('handleSortChanged: ' + JSON.stringify(e));

    if (!_.isEqual(this.state.sortData, e)) {
      let sortData = _.cloneDeep(this.state.sortData);

      // TODO: joe- handle this case

      this.setState({ sortData }, this.invalidateData);
    }
  }

  handlePageChanged(e) {
    // console.log('handlePageChanged: ' + JSON.stringify(e));

    if (this.state.pageData.activePageIdx !== e.activePageIdx) {
      let pageData = _.cloneDeep(this.state.pageData);
      pageData.activePageIdx = e.activePageIdx;

      this.setState({ pageData }, this.invalidateData);
    }
  }

  handleRowClicked(movieItem) {
    // navigate to edit page
    let id = _.get(movieItem, 'id', null);
    this.props.history.push('/movies/edit/' + id);
  }

  invalidateData() {
    let q = {};
    q = _.extend(q, _paginationOpts);

    q.p = (this.state.pageData.activePageIdx || 0) + _pageNumOffset;

    if (this.state.tableSearch && !_.isEmpty(this.state.tableSearch)) {
      q.f = 'title|' + this.state.tableSearch;
      q.p = _pageNumOffset;    // revert to first page when searching
    }

    // console.log('invalidateData: tableSort: ' + JSON.stringify(this.state.tableSort));

    // sort field and sort order
    if (this.state.tableSort) {
      q.sf = _.replace(this.state.tableSort.column, /_?Formatted$/i, '');
      q.so = this.state.tableSort.direction || 'asc';
    } else {
      q.sf = 'release_date';
      q.so = 'desc';
    }

    if (this.prevQuery && _.isEqual(this.prevQuery, q)) {
      return false;
    }
    this.prevQuery = q;


    return api.movies.find(q).then(res => {
      let items = _.get(res, 'data') || null;
      items = _.chain(items)
        .map(item => {
          if (!item) { return null; }
          item.titleFormatted = this.movieHelper.formatPosterAndTitle(item);
          item.is3DFormatted = this.movieHelper.format3D(item);
          item.duration_minsFormatted = this.movieHelper.formatDuration(item);
          item.release_dateFormatted = this.movieHelper.formatReleaseDate(item);
          return item;
        })
        .compact()
        .value();

      let pageData = _.cloneDeep(this.state.pageData);

      let meta = _.get(res, 'meta') || null;
      if (meta) {
        pageData.activePageIdx = meta.pageNumber - _pageNumOffset;
        pageData.numItems = meta.totalRecords;
        pageData.numTotalPages = meta.totalPages;
        pageData.numTotalItems = meta.totalRecords;
        pageData.lastPageIdx = pageData.numTotalPages - 1;
     }

      this.setState({ items, pageData });
      return true;
    });
  }

  render() {

    let tableData = this.state.items;
    let sortData = this.state.sortData;
    let pageData = this.state.pageData;

    return (
      <div className="movies-list-view mx-auto">
        <Card>
          <CustomDataTable
            showStrippedRows={true}
            showAddButton={true}
            showSearch={true}
            showSort={true}
            showPaging={true}

            onAddClicked={this.handleAddClicked}
            onSearchChanged={this.handleSearchChanged}
            onSortChanged={this.handleSortChanged}
            onPageChanged={this.handlePageChanged}
            onRowClicked={this.handleRowClicked}

            headers={_columnHeaders}
            data={tableData}

            title="Manage Movies"
            searchLabel={''}
            sortData={sortData}
            pageData={pageData}
          />
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}


const mapDispatchToProps = {
  setDefaultAddMovieTitle,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MoviesListView));

